module.exports = __webpack_public_path__ + "static/media/health.dff06b9f.jpg";